import type { EquipmentTypeResponseItem } from '../types/EquipmentTypes';

import { restClient } from './restClient';

export const getEquipmentTypes = () => {
  return restClient.get<EquipmentTypeResponseItem[]>('/api/equipment-type');
};
